import React from "react";

function Contact() {
  return (
    <div className="flex flex-col items-center min-h-screen p-8 bg-[#fafafa]">
      <img src="/images/contact_booth.png" alt="" className="h-[275px] md:h-[300px]" />
      <p className="mb-6 md:mb-4 text-[12px] md:text-[14px]">Leafwell Farm - zen work private-suite on site</p>
      <h1 className="text-5xl md:text-6xl font-semibold text-black mb-10">
        SAY HELLO
      </h1>
      <p className="text-base md:text-lg font-normal text-black mb-3 text-center">
        We are excited to welcome you.
      </p>

      <p className="text-base md:text-lg font-normal text-black text-center">
        Email:{" "}
        <a
          href="mailto:contact@hideout.please"
          className="text-blue-600 underline"
        >
          info@leafwellfarm.com
        </a>
      </p>

      <p className="text-base md:text-lg font-normal text-black text-center">
        Live Text: 347 370 2217
      </p>
    </div>
  );
}

export default Contact;
